<template>
    <svg
        class="icon-eye"
        viewBox="0 0 27.02 14.85"
        xmlns="http://www.w3.org/2000/svg"
    ><path d="M13.51,14.85C6.11,14.85.25,8.2,0,7.92v-1C.25,6.65,6.11,0,13.51,0S26.78,6.65,27,6.93v1C26.78,8.2,20.91,14.85,13.51,14.85ZM1.6,7.43c1.48,1.5,6.31,5.92,11.91,5.92S23.94,8.93,25.43,7.43C24,5.92,19.11,1.5,13.51,1.5S3.08,5.92,1.6,7.43Z" /><path d="M13.51,11.12a3.75,3.75,0,1,1,3.75-3.75A3.75,3.75,0,0,1,13.51,11.12Zm0-6a2.25,2.25,0,1,0,2.25,2.25A2.25,2.25,0,0,0,13.51,5.12Z" /></svg>
</template>